// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__3H3X8","Footer":"Layout_Footer__1-MLx"};